import React from "react";
import { useTranslation } from "react-i18next";


interface IProps {
    type: "android" | "ios";
    /**Link to the app `(optional)`. Will default to the Android or IOS Tee On App link based on the type prop */
    url?: string;
    /**Height in pixels `(optional). Default is 40px` */
    height?: number;
}

const ANDROID_TEE_ON_APP = "https://play.google.com/store/apps/details?id=com.teeon";
const IOS_TEE_ON_APP = "https://apps.apple.com/kg/app/tee-on/id6476159748";

export default function AppStoreBadge(props: IProps) {
    const {type, url = type === "android" ? ANDROID_TEE_ON_APP : IOS_TEE_ON_APP, height = 40} = props;
    const {t} = useTranslation();

    return (
        <div>
               <a 
               href={url}
               target="_blank"
                rel="noopener noreferrer"
               >
                    <img 
                        src={type === "android" ? "/public/images/appStoreBadges/google-play-badge.png" : "/public/images/appStoreBadges/app-store-badge.svg"} 
                        alt={type === "android" ? t("Get it on Google Play") : t("Download on the App Store")}
                        style={{height: `${height}px`}}
                    />
               </a> 
        </div>
    );
}